import '@hotwired/turbo-rails'
import '@/controllers'
import '@/analytics/google_analytics'

// Vendor assets
import WOW from 'wow.js'

// Initialize WOW
new WOW().init()
